// extracted by mini-css-extract-plugin
export default {"socialLinksForm":"styles_socialLinksForm__DAX1d","loader":"styles_loader__PiJgk"};